import { Button, Group, Modal, Stack, TextInput } from "@mantine/core";
import { IconKey } from "@tabler/icons-react";
import { useState } from "react";
import { createApiKey } from "../../../../../api/ConfigsApi";
import { notifications } from "@mantine/notifications";
import { useLanguage } from "../../../../../stores/LanguageStore";
import BackButton from "../../../../../components/View/BackButton";

const AddApiKey = ({ onFinish, ...props }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);

  const [opened, setOpened] = useState(false);
  const handleOpen = () => {
    setOpened(true);
  };

  const handleClose = () => {
    setOpened(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let fd = new FormData(e.target);
    let data = Object.fromEntries(fd);

    setLoading(true);
    createApiKey(data?.name)
      .then((response) => {
        setTimeout(() => {
          notifications.show({
            message: lang.api_keys.row_highlight.created,
            color: "tertiary.8",
          });
        }, 300);
        handleClose()
        onFinish?.();
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Button
        size="md"
        leftSection={<IconKey />}
        onClick={handleOpen}
        {...props}
      >
        {lang.settings.create_api}
      </Button>

      <Modal
        title={lang.integrations.create.dialog.title}
        opened={opened}
        onClose={handleClose}
      >
        <Stack mx={"auto"} component={"form"} onSubmit={handleSubmit}>
          <TextInput
            name="name"
            label={lang.api_keys.create.dialog.name}
            placeholder={lang.api_keys.create.dialog.name}
            autoFocus
            data-autofocus
            size="md"
            required
          />

          <Group justify="flex-end" mt={"md"}>
            <BackButton onClick={handleClose} />
            <Button type="submit" loading={loading} size="md">
              {lang.api_keys.create.dialog.submit_button}
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
};

export default AddApiKey;
